// Función para obtener la clase CSS de fila deshabilitada
export const getDisabledRowClass = (isDisabled) => isDisabled ? 'disabled-row' : '';

// Función para crear el botón de toggle de estado
export const createToggleButton = (isDisabled, onToggle, size = "sm", className = "me-2") => ({
    variant: isDisabled ? "success" : "secondary",
    onClick: onToggle,
    size,
    className,
    text: isDisabled ? "Habilitar" : "Deshabilitar"
});